import { render, staticRenderFns } from "./personalCommonHeader.vue?vue&type=template&id=635e44a4&scoped=true"
import script from "./personalCommonHeader.vue?vue&type=script&lang=js"
export * from "./personalCommonHeader.vue?vue&type=script&lang=js"
import style0 from "./personalCommonHeader.vue?vue&type=style&index=0&id=635e44a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e44a4",
  null
  
)

export default component.exports